<template>
  <div class="Collection">
      <Course/>
  </div>
</template>

<script>
import Course from '../teachers/compontents/course'
export default {
components:{
    Course
}
}
</script>
<style lang="less" scoped>
.Collection{
    width: 100%;
    margin:11px 20px 
}
</style>